import jMoment from 'moment-jalaali';

//Convert degree from kelvin to celcius and round it
function convertDegree(kelvinDegree) {
    return kelvinDegree - 270;
}

async function callWeatherApi() {
    return await fetch('http://api.openweathermap.org/data/2.5/forecast?lat=35.69&lon=51.42&units=metric&apikey=a6a44e532d2a339974cf85c635ed1a90')
        .then(response => {
            return response.json()
        }).then(json => {
            return json
        });
}

async function createWeatherData() {
    let responseResult = await callWeatherApi();
    let list = responseResult.list;

    //--avalin record ke baraye alan baghe ro begir va saat 12, 2 Rooz baad ro
    let count = 0;
    list = list.filter(x => {
        count++;
        return x.dt_txt.includes('12:00') || count === 1
    }).slice(0, 5);


    jMoment.loadPersian({dialect: 'persian-modern'});
    return {
        city: {
            name: "تهران",
            dateTime: jMoment(new Date()).format('LLLL'),
            country: "ایران",
        },
        list: list
    }
}


export const weatherData = createWeatherData();


/*Sample data*/
/*

[
    {
        dt: 1487246400,
        main: {
            temp: 28,
            temp_min: 28,
            temp_max: 28,
            pressure: 98,
            sea_level: 102,
            grnd_level: 98,
            humidity: 94,
            temp_kf: 0.25
        },
        weather: [
            {
                id: 501,
                main: "Rain",
                description: "moderate rain",
                icon: "10n"
            }
        ],
        clouds: {
            all: 92
        },
        wind: {
            speed: 2.41,
            deg: 189.001
        },
        rain: {
            "3h": 3.385
        },
        sys: {
            pod: "n"
        },
        dt_txt: "2017-11-16 12:00:00"
    },
    {
        dt: 1487257200,
        main: {
            temp: 284.04,
            temp_min: 283.846,
            temp_max: 284.04,
            pressure: 987.85,
            sea_level: 1026.69,
            grnd_level: 987.85,
            humidity: 99,
            temp_kf: 0.19
        },
        weather: [
            {
                id: 501,
                main: "Rain",
                description: "moderate rain",
                icon: "10d"
            }
        ],
        clouds: {
            all: 100
        },
        wind: {
            speed: 2.57,
            deg: 175.001
        },
        rain: {
            "3h": 11.005
        },
        sys: {
            pod: "d"
        },
        dt_txt: "2017-11-15 15:00:00"
    },
    {
        dt: 1487268000,
        main: {
            temp: 285.5,
            temp_min: 285.373,
            temp_max: 285.5,
            pressure: 988.68,
            sea_level: 1027.48,
            grnd_level: 988.68,
            humidity: 100,
            temp_kf: 0.13
        },
        weather: [
            {
                id: 501,
                main: "Rain",
                description: "moderate rain",
                icon: "10d"
            }
        ],
        clouds: {
            all: 100
        },
        wind: {
            speed: 1.21,
            deg: 207
        },
        rain: {
            "3h": 4.325
        },
        sys: {
            pod: "d"
        },
        dt_txt: "2017-11-14 18:00:00"
    },
    {
        dt: 1487278800,
        main: {
            temp: 286.29,
            temp_min: 286.228,
            temp_max: 286.29,
            pressure: 987.96,
            sea_level: 1026.59,
            grnd_level: 987.96,
            humidity: 100,
            temp_kf: 0.06
        },
        weather: [
            {
                id: 500,
                main: "Rain",
                description: "light rain",
                icon: "10d"
            }
        ],
        clouds: {
            all: 92
        },
        wind: {
            speed: 1.39,
            deg: 163.502
        },
        rain: {
            "3h": 1.565
        },
        sys: {
            pod: "d"
        },
        dt_txt: "2017-11-13 21:00:00"
    },
]*/



// WEBPACK FOOTER //
// ./components/Weather/weatherData.js